// components/AssetReportTable.tsx
import React, { forwardRef, useCallback, useEffect, useMemo, useState } from 'react';
import {useLocation } from 'react-router-dom';
import MaterialTable from 'material-table';
import { tableIcons } from '../../../pages/new-ticket/AddAsset';
import {  AssetReportRow } from './types';
import { COLUMN_LABELS } from './constants';
import { Box, Button, List, ListItem, ListItemSecondaryAction, ListItemText } from '@mui/material';
import Popover from "@mui/material/Popover";
import Switch from "@mui/material/Switch";
interface AssetReportTableProps {
  data: AssetReportRow[];
  loading: boolean;
  handleColumnChange: (columns: any) => void;
  initialValues?: {
    columns: string[];
  };
}

export const AssetReportTable: React.FC<AssetReportTableProps> = ({ data, loading, initialValues, handleColumnChange }) => {
  const pageUrl = useLocation();
  const subRoute = pageUrl.pathname.split("/")[1]
  const [anchorEl,setAnchorEl] = React.useState<null | HTMLElement>(null);
 const [columns, setColumns] = React.useState(() => {
  const savedColumns = initialValues?.columns ?? [];

  const orderedFields =
    savedColumns.length > 0
      ? [
          ...savedColumns,
          ...Object.keys(COLUMN_LABELS).filter(
            (field) => !savedColumns.includes(field)
          ),
        ]
      : Object.keys(COLUMN_LABELS);

  return orderedFields.map((field) => {
    const hidden = initialValues
      ? !savedColumns.includes(field)
      : false;

    return {
      title: COLUMN_LABELS[field],
      field,
      hidden,
      hiddenByColumnsButton: hidden,
      cellStyle: {
        width: "250px",
        whiteSpace: "nowrap" as const,
        overflow: "hidden",
        textOverflow: "ellipsis",
        fontSize: "12px",
        maxWidth: "500px",
      },
      headerStyle: {
        whiteSpace: "nowrap" as const,
      },
    };
  });
});



  useEffect(() => {
    if (columns.length) {
      handleColumnChange(columns);
    }
  }, [columns, handleColumnChange]);

  const handleColumnDrag = useCallback(
  (sourceIndex: number, destinationIndex: number) => {
    setColumns(prev => {
      const updatedColumns = [...prev];
      const [movedColumn] = updatedColumns.splice(sourceIndex, 1);

      updatedColumns.splice(destinationIndex, 0, movedColumn);
      return updatedColumns;
    });
  },
  []
  );
 // Column handlers
   const handleToggleClick = (event: React.MouseEvent<HTMLElement>) => {
     setAnchorEl(event.currentTarget);
   };
 
   const handlePopoverClose = () => {
     setAnchorEl(null);
   };

const toggleColumnVisibility = useCallback((
    field: string, 
    toggleAll?: boolean, 
    value?: boolean
  ) => {
    setColumns(prev => {
      const updated:any = prev.map(col => 
        toggleAll ? { ...col, hidden: value } :
        col.field === field ? { ...col, hidden: !col.hidden } : col
      );
      return updated;
    });

    // if (field === "AdditionalField" || toggleAll) {
    //   setDynamicColumns(prev =>  prev.map(col => ({ ...col, hidden: value ?? !col.hidden })))
    // }
  }, []);


  const popoverContent = useMemo(() => (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={handlePopoverClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    >
      <Box className="text-center pt-1" sx={{display: 'flex', spaceBetween: '10px', gap: '10px', paddingLeft:'49px'}}>
        <Button variant="contained" size="small" onClick={() => toggleColumnVisibility("", true, false)}>
          Show All
        </Button>
        <Button variant="contained" size="small" onClick={() => toggleColumnVisibility("", true, true)}>
          Hide All
        </Button>
      </Box>
      <List>
        {columns.map(col => (
          <ListItem key={col.field} className="fields-list-toggler">
            <ListItemText primary={col.title} />
            <ListItemSecondaryAction>
              <Switch
                size="small"
                checked={!col.hidden}
                onChange={() => toggleColumnVisibility(col.field)}
              />
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
    </Popover>
  ), [anchorEl, columns, toggleColumnVisibility])

  return (
    <div className="position-relative" style={{ maxHeight: "calc(100vh - 170px)" }}>
      {subRoute == "ViewAssetsCSVReport" ? ""
      :  <>
          <Button variant='contained' className="assets-csv-manage-col-btn" onClick={handleToggleClick}>Manage Columns</Button>
          {popoverContent}
        </>
      }
     
      <MaterialTable
        columns={columns}
        title=""
        data={data}
        isLoading={loading}
        icons={tableIcons}
        onColumnDragged={handleColumnDrag}
        options={{
          exportAllData: true,
          exportButton:  {
            csv: true,
            pdf: false,
          },
          pageSize: 50,
          pageSizeOptions: [25, 50, 100, 250],
          maxBodyHeight: "calc(100vh - 270px)",
          emptyRowsWhenPaging: false,
        }}
        // icons={tableIcons}
        localization={{
          toolbar: {
            exportTitle: 'Export CSV',
            exportCSVName: 'Export to CSV',
          }
        }}
      />
    </div>
  );
};